export default __webpack_public_path__ + "static/media/yeezy_product_page.a570f882.png";